import { render, staticRenderFns } from "./product-row.vue?vue&type=template&id=23c15a56&scoped=true&"
import script from "./product-row.vue?vue&type=script&lang=js&"
export * from "./product-row.vue?vue&type=script&lang=js&"
import style0 from "./product-row.vue?vue&type=style&index=0&id=23c15a56&scoped=true&lang=scss&"
import style1 from "./product-row.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c15a56",
  null
  
)

export default component.exports